import {IToJson} from '@toolify/client/src/types/IToJson'
import {
  ICollectionItemResponseInstance,
} from '@toolify/server/src/adapters/InstanceApiResponseAdapter/types/responseInstances/ICollectionItemResponseInstance'

export function mapCollectionItemResponseInstance(
  collectionItem: IToJson<ICollectionItemResponseInstance>,
): ICollectionItemResponseInstance {
  return {
    ...collectionItem,
  } as ICollectionItemResponseInstance
}
